import { AppStore } from "./AppStore";
import { signup } from "../../../../../common";
import { computed } from "mobx";
import { UserLanguagesStore } from "#glib/data/user/UserLanguagesStore";
import api from "../api";
import { ObservableStore } from "#glib/data/core/obvservable";

// --

export interface ISignupClientData extends Pick<signup.IData, "orgName" | "firstName" | "lastName" | "email" | "lang"> {
	ackTos: boolean;
}

// Signuo data
const signupInitData: signup.IData = (window as any).__signup?.data ? JSON.parse(atob((window as any).__signup?.data)) : {};

console.log({ signupInitData });

const signupData: ISignupClientData = {
	firstName: signupInitData.firstName,
	lastName: signupInitData.lastName,
	email: signupInitData.email,
	orgName: signupInitData.orgName,
	lang: signupInitData.lang ?? null,
	ackTos: false,
};

// Meta
export interface IMetaData {
	signedUpMessage: string;
	error: string;
	busy: boolean;
}

/**
 * DataDomain
 */
export class DataDomain extends ObservableStore<ISignupClientData> {
	public readonly initData = signupData;
	public readonly meta: ObservableStore<IMetaData>;
	public readonly languages: UserLanguagesStore<"lang", ISignupClientData>;

	public redirectUrl: string = null;

	/**
	 * Class constructor
	 * @param appStore
	 */
	public constructor(public readonly appStore: AppStore) {
		super(signupData, {
			rules: {
				firstName: (key, value) => {
					if (value.length < 2) return "Min. 2 charaters long";
					if (value.length > 40) return "Max. 40 charaters long";
					return void 0;
				},
				lastName: (key, value) => {
					if (value.length < 2) return "Min. 2 charaters long";
					if (value.length > 40) return "Max. 40 charaters long";
					return void 0;
				},
				organization: (key, value) => {
					if (value.length < 3) return "Min. 3 charaters long";
					if (value.length > 40) return "Max. 40 charaters long";
					return void 0;
				},
			},
		});

		// Meta
		this.meta = new ObservableStore<IMetaData>({
			signedUpMessage: null,
			error: null,
			busy: false,
		});

		this.languages = new UserLanguagesStore(this, "lang");
	}

	/**
	 * Is busy
	 */
	public get isBusy() {
		return this.meta.data.busy;
	}

	/**
	 * Errors
	 */
	public get errors() {
		return api.errors;
	}

	/**
	 * Signup error
	 */
	public get signedUpMessage() {
		return this.meta.data.signedUpMessage;
	}

	/**
	 * Ready to submit
	 */
	@computed public get canSubmit() {
		if (!this.data.ackTos) return false;
		if (!this.data.firstName) return false;
		if (!this.data.lastName) return false;
		if (!this.data.email) return false;
		if (!this.appStore.orgJoinInviteId && !this.data.orgName) return false;

		return !this.validation.hasErrors;
	}

	/**
	 * Submit onboarding data
	 */
	public submit = async () => {
		if (this.isBusy) return;

		this.meta.mset({ busy: true });

		const res = await api.submit(this.toJS());

		this.meta.mset(
			{
				busy: false,
			},
			() => {
				if (res) {
					this.redirectUrl = res.redirect ?? null;
					if (res.message) this.meta.set("signedUpMessage", res.message);
					if (res.error) this.meta.set("error", res.error);
				}
			}
		);
	};
}
